export default __webpack_public_path__ + "static/media/icons8-cloud-share-symbol-100.59826dbb.svg";